module.exports = __webpack_public_path__ + "img/水杯4.dc6dab75.png";